// import react library
import { motion } from 'framer-motion';

// style imports and imports from utils
import { headingAnimation, useAnimationHook } from 'Utils/animation';
import './PrivacyCard.css';

const PrivacyCard = ({data}) => {
    const {ref, mainControls}=useAnimationHook(0.5)
  return (
    <motion.div className='padding_container privacy_card_container'
    ref={ref} initial="hidden" animate={mainControls} transition={{staggerChildren:0.2}}>
        <div className='privacy_card_art_container mues_row_center'>
            <img src={data.art} alt="privacy-art" />
        </div>
        <div className="mues_black main_privacy_card">
            <motion.h4 className="mues_font_weight_700" variants={headingAnimation}>{data.title}</motion.h4>
            <motion.h6 className="mues_font_weight_400"
            variants={headingAnimation}>{data.description}</motion.h6>
            <motion.div className="mues_row_flex mues_column_gap_16"
            variants={headingAnimation}>
                {data.iconList.map(item=>(
                    <div className="landing_page_main_card_icon_container mues_row_center
                    mues_green_background_gradient mues_green_shadow" key={item.id}>
                        {item.icon}
                    </div>
                ))}
            </motion.div>  
        </div>
    </motion.div>
  )
}

export default PrivacyCard